import { useCallback, useEffect, useState } from "react";
import { fetchTaskDetail } from "../../models/shared/taskDetailModel";

export function useTaskDetail(queryPk, { userId } = {}) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const refetch = useCallback(async () => {
    if (!queryPk) {
      setData(null);
      return null;
    }
    setLoading(true);
    const result = await fetchTaskDetail(queryPk, userId != null ? { userId } : {});
    // fetchTaskDetail resolves null on any failure (network hiccup, transient
    // backend error) — don't let a failed background refresh wipe out
    // already-displayed, valid data. WorkflowTaskDrawer treats data === null
    // as "no task" and blanks its body, including the nested PriceUpdateDrawer
    // (its card prop derives from task, and PriceUpdateDrawer resets its own
    // parts to [] the moment card?.id goes away) — with no way to recover
    // short of closing and reopening. Keeping the stale-but-valid data instead
    // means a flaky refetch just silently retries next time instead of
    // blanking the UI.
    if (result != null) setData(result);
    setLoading(false);
    return result;
  }, [queryPk, userId]);

  useEffect(() => {
    if (!queryPk) {
      setData(null);
      return;
    }
    refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryPk, userId]);

  return { data, loading, refetch };
}
